import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function NotificationsPage(): JSX.Element {
  return (
    <ConfigSection
      title={"Notificações: templates, canais e tokens inválidos"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      'Endpoints de notificação (F-09) não implementados.',
      'Push real exige `EXPO_ACCESS_TOKEN` e credenciais FCM/APNs.'
]}
      planned={[
      'Inbox persistida, tokens por dispositivo/ambiente e invalidação.',
      'Payload mínimo: ID opaco e tipo, sem nome, valor, nota ou documento.'
]}
    />
  );
}